export default __webpack_public_path__ + "static/media/imageProvisional.98aa760e.jpg";